<template>
  <div v-if="client">
    <router-view />
  </div>
</template>
<script>
  import state from '../../state'
  import breadcrumbsService from '../../services/breadcrumbs.service'

  export default {
    name: 'client',
    computed: {
      client() {
        return state.client.get();
      }
    },
    async mounted() {
      breadcrumbsService.dynamic.set({ key: 'client', func: () => this.client ? this.client.name : '' });
    }
  }
</script>
<style scoped>
  .oc-client {
    color: #c02c2c !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/client/index.vue